<div class="product-buy-option-bar {{isEnabled() ? '' : ' product-buy-option-bar--disabled'}}">
	<form (ngSubmit)="onSubmit(addToCart.value)" [formGroup]="addToCart">
		@if (product.saleDiscount > 0) {
			<div class="product-buy-option-bar_price product-buy-option-bar_price--discount">
				<s class="product-detail original-price">
					{{ applicationService.getUserCurrency() }}
					{{ itemPrice | number: "1.2-2" }}
				</s>

				{{ applicationService.getUserCurrency() }}&nbsp;{{ unitPrice | number: "1.2-2" }}
			</div>
		}

		@if (product.saleDiscount == 0) {
			<div class="product-buy-option-bar_price">
				{{ applicationService.getUserCurrency() }}&nbsp;{{ unitPrice | number: "1.2-2" }}
			</div>
		}

		<div class="product-buy-option-bar_input">
			<div class="quantity-input_container">
				@if (isEnabled()) {
					<button (click)="minQuantity()"
					        [disabled]="minDisabled()"
					        class="quantity-input_minus"
					        i18n-title="@@minimum.order.quantity"
					        title="The minimum order quantity is {{ minimumOrderQuantity }} x {{itemsPerUnit}}"
					        type="button">

						<svg class="icon-minus" height="2" viewBox="0 0 9 2" width="9">
							<use xlink:href="/images/icons/svg-sprite.svg#minus"></use>
						</svg>
					</button>

					<input (blur)="changeQuantity()"
					       [attr.max]="getMaximumOrderQuantity()"
					       [attr.min]="minimumOrderQuantity"
					       [formControl]="addToCart.controls['quantity']"
					       autocomplete="off"
					       class="quantity-input_input"
					       i18n-title="@@minimum.order.quantity"
					       required
					       title="The minimum order quantity is {{ minimumOrderQuantity }} x {{itemsPerUnit}}"
					       type="number" />

					@if (!product.isStockProduct) {
						<button (click)="plusQuantity()"
						        [disabled]="plusDisabled()"
						        class="quantity-input_plus"
						        type="button">

							<svg class="icon-plus" height="10" viewBox="0 0 9 10" width="9">
								<use xlink:href="/images/icons/svg-sprite.svg#plus"></use>
							</svg>
						</button>
					}

					@if (product.isStockProduct) {
						<button (click)="plusQuantity()"
						        [disabled]="plusDisabled()"
						        class="quantity-input_plus"
						        i18n-title="@@maximum.order.quantity"
						        title="The maximum order quantity is {{ getMaximumOrderQuantity() }} x {{itemsPerUnit}}"
						        type="button">

							<svg class="icon-plus" height="10" viewBox="0 0 9 10" width="9">
								<use xlink:href="/images/icons/svg-sprite.svg#plus"></use>
							</svg>
						</button>
					}
				}
			</div>
		</div>

		<div class="product-buy-option-bar_button">
			<button [attr.disabled]="isEnabled() ? null : 'disabled'"
			        class="button button--small {{buttonShowPressed ? 'button--product-added' : ''}} {{isEnabled() ? '' : 'button--disabled'}} button--icon-right button--text-left theme-btn-secondary"
			        type="submit">

				@if (!showConfirmation) {
					@if (!buttonShowPressed) {
						@if (isEnabled()) {
							<render-checkout-icon [fastCheckout]="isFastCheckout()"
							                      [iconHeight]="16"
							                      [iconWidth]="31">
							</render-checkout-icon>
						}
					}

					@if (buttonShowPressed) {
						<svg class="icon-spinner" height="14" width="14">
							<use xlink:href="images/icons/svg-sprite.svg#spinner"></use>
						</svg>
					}
					{{ unitDescription }}
				}

				@if (showConfirmation) {
					<svg class="icon-check" height="14" width="16">
						<use xlink:href="images/icons/svg-sprite.svg#check"></use>
					</svg>

					<strong class="product-buy-option-bar_confirmation"
					        i18n="Label shown after products were added@@buy.options.products.added">
						Products added
					</strong>
				}
			</button>
		</div>
	</form>
</div>
